/**
 * Resolves the expense-create path based on company asset type.
 * Household assets use the receipt-scan & split flow; all others keep the classic form.
 */
export function getStoredAssetType() {
    return (localStorage.getItem('assetType') || '').trim();
}

/**
 * True when localStorage.assetType is exactly "Household" (case-sensitive).
 * Optional override arg kept for existing dashboard callers that pass a value.
 */
export function isHouseholdAssetType(assetType) {
    const value =
        assetType != null && String(assetType).trim() !== ''
            ? String(assetType).trim()
            : localStorage.getItem('assetType');
    return value === 'Household';
}

/** Classic create path — unchanged for non-household assets. */
export const EXPENSE_CREATE_PATH = '/expenses/create';

/** Household receipt-split create path. */
export const EXPENSE_CREATE_HOUSEHOLD_PATH = '/expenses/create-household';

/**
 * @param {string|object} [fallbackOrQuery] — optional query object, or ignored string
 * @returns {string|{path:string,query?:object}}
 */
export function resolveExpenseCreateRoute(query) {
    const path = isHouseholdAssetType()
        ? EXPENSE_CREATE_HOUSEHOLD_PATH
        : EXPENSE_CREATE_PATH;

    if (query && typeof query === 'object' && Object.keys(query).length) {
        return { path, query };
    }
    return path;
}
